import BaseComponent from "../../../../../lib/components/BaseComponent";
import FilterListDialog from "../../../../../appl/view/components/filterManager/FilterListDialog";
import Button from "../../../../../appl/view/components/buttons/Button";
import React from "react";

class FilterManagerTest2 extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      isFilterListDialogOpen: false,
      filterListRows: [],
      filterListData: [],
      campaignId: '87',
      entityName: 'entity/contact'
    }
    this.sysLastValueId = FilterListDialog.buildSysLastValueId(this.state.campaignId, this.state.entityName);
  }

  doLoadFilterListDialog = (callback) => {
    FilterListDialog.loadFilterList(this.sysLastValueId, (filterListRows, filterListData) => {
      this.setState({filterListRows: filterListRows, filterListData: filterListData});
      if (callback) {
        callback();
      }
    });
  }

  doShow(event) {
    this.doLoadFilterListDialog(() => {
      this.setState({isFilterListDialogOpen: true});
    });
  }

  render() {
    let query = {startRow: 0, endRow: 9};
    return <div className='sandbox-container flex flex-col gap-4'>
      <h1>FilterManager test</h1>
      <Button onClick={(event) => this.doShow(event)}>
        show 1
      </Button>
      <Button onClick={(event) => {alert('klick')}}>
        show 2
      </Button>
      <div>
        <FilterListDialog parent={this}
                          open={this.state.isFilterListDialogOpen}
                          rows={this.state.filterListRows}
                          data={this.state.filterListData}
                          canClose
                          canEdit
                          displayMode={'outline'}
                          query={query}
                          campaignId={this.state.campaignId}
                          entityName={this.state.entityName}
                          onClose={() => {
                            this.setState({isFilterListDialogOpen: false});
                          }} onDone={() => {
        }}/>
      </div>
    </div>
  }
}

export default FilterManagerTest2;
